import Vue from 'vue'
import Router from 'vue-router'

import Dashboard from './views/Dashboard.vue'
import Login from './views/Login.vue'

import Units from './views/units/Units.vue'
import Courses from './views/courses/Courses.vue'
import Course from './views/courses/Course.vue'
import Users from './views/users/Users'
import Rooms from './views/rooms/Rooms'
import Classes from './views/classes/Classes.vue'
import ClassPos from './views/classes/ClassPos.vue'

Vue.use(Router)

export default new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  routes: [
    {
      path: '/',
      name: 'dashboard',
      component: Dashboard
    },
    {
      path: '/units',
      name: 'units',
      component: Units
    },
    {
      path: '/courses',
      name: 'courses',
      component: Courses
    },
    {
      path: '/course/:id',
      name: 'course',
      component: Course
    },
    {
      path: '/classes',
      name: 'classes',
      component: Classes
    },
    {
      path: '/class/pos/:id',
      name: 'classPos',
      props: true,
      component: ClassPos
    },
    {
      path: '/rooms',
      name: 'rooms',
      component: Rooms
    },
    {
      path: '/users',
      name: 'users',
      component: Users
    },
    {
      path: '/login',
      name: 'login',
      component: Login
    }
  ]
})
